<template>
  <div class="flex flex-col h-screen">

    <nav class="bg-footerColor">
      <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div class="relative flex h-16 items-center justify-between">

          <div class="flex flex-1 items-center justify-between">
            <div class="flex items-center">
              <img class="h-12 w-auto" style="cursor: pointer;" @click="goback()" src="@/assets/images/logo.jpeg" alt="HAWK RENT A CAR" />
            </div>
            <div class="hidden sm:flex items-center justify-center flex-grow">
              <h1 class="font-bold text-white cursor-pointer" @click="$router.replace('/')">
                HAWK RENT A CAR
              </h1>
            </div>
            <div class="flex items-center">

            </div>
          </div>
          <update-booking :showManageBooking="showManageBooking"
            @update:showManageBooking="val => showManageBooking = val" />
        </div>
      </div>

    </nav>

    <router-view>


    </router-view>
    <div class="flex-grow"></div>
    <!-- <footer class="text-center text-sm text-white py-4 px-4 bg-footerColor w-full">
      <div>
        Privacy Statement | Cookies | Terms of service | Help | Modern Slavery
        Statement | How We Work | Supply Partner Enquiry and Marketplace |
        Affiliate Programme | Careers | Contact Us
      </div>
      <div class="mt-3">
        © {{ new Date().getFullYear() }} Hawkrentacar. All rights reserved
      </div>
    </footer> -->
  </div>
</template>
<script>
import updateBooking from '@/components/hawk/updateBooking.vue'
export default {
  components: {
    updateBooking,
  },
  data() {
    return {
      showManageBooking: false,
    };
  },
  methods: {
    toggleCollapsible(index) {
      if (this.activeCollapsible === index) {
        this.activeCollapsible = 0;
      } else {
        this.activeCollapsible = index;
      }
    },
    goback(){
      window.location.href='https://www.hawkrentacar.com.my';
    }
  },
};
</script>
